import client from '../client';
import * as invoiceMutations from "../mutations/invoice";
import * as invoiceQueries from "../queries/invoice";

export function getInvoices(success, error, fogId, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { fogId: fogId },
        fetchPolicy: fetchPolicy,
        query: invoiceQueries.all,
    })
        .then(success)
        .catch(error);
}


export function get(success, error, id, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { id: id },
        fetchPolicy: fetchPolicy,
        query: invoiceQueries.get,
    })
        .then(success)
        .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { invoice: data },
        mutation: invoiceMutations.add,
    }).then(success).catch(error);;
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, invoice: data },
        mutation: invoiceMutations.edit,
    }).then(success).catch(error);
}

export function remove(success, error, data) {
    client.mutate({
        variables: { id: data },
        mutation: invoiceMutations.remove,
    }).then(success).catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/invoice.js